import { Component, OnInit, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { FormValidatorService } from "../../../../../../shared/services/form-validator.service";
import { Validators } from "../../../../../../shared/validators";
import { CustomValidators } from "../../../../../../shared/custom-validators";
import { PromocodeModalComponent } from "../promocode-modal/promocode-modal.component";
import { GetSystemPromocodeService } from "../services/get-system-promocode.service";
import { CreateSystemPromocodeService } from "../services/create-syetem-promocode.service";
import { EditSystemPromocodeService } from "../services/edit-system-promocode.service";
import { FetchPaymentOptionsForAdminService } from "../../../../../../shared/services/fetch-payment-options-for-admin.service";

@Component({
  selector: 'app-add-promocode',
  templateUrl: './add-promocode.component.html',
  styleUrls: ['./add-promocode.component.scss']
})
export class AddPromocodeComponent implements OnInit, OnDestroy {
  error: any;
  Datenow = new Date();
  formValidator = new FormValidatorService();
  promoCodeFrom!: FormGroup;
  paymentOptions: any[] = [];
  validationError!: [
      {
          field: string;
          message: string;
          validation: string;
      }
  ];
  editMode: boolean = false;
  minQuantity = 1;
  selectedPaymentOption = 0;
  maxQuantity = 100;
  patternName = "^[_A-z0-9]*((-|s)*[_A-z0-9])*$";
  patternQuantity = "d{1,2}";
  subscription!: Subscription;

  constructor(
    public createSystemPromo: CreateSystemPromocodeService,
    private translate: TranslateService,
    public fetchPaymentOptionsService: FetchPaymentOptionsForAdminService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private getSystemPromocodeService: GetSystemPromocodeService,
    private editSystemPromocodeService: EditSystemPromocodeService,
  ) { }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(async a => {
      if (a["promocodeName"]) {
        this.editMode = true;
        this.getSystemPromocodeService.setParams({ codeName: a["promocodeName"] });
        const response = await this.getSystemPromocodeService.make();
        this.minQuantity = response.promocode.redeemedQuantity;
        this.selectedPaymentOption = response.PaymentOptionId;
        await this.initForm();

        this.promoCodeFrom.controls["codeName"].setValue(response.promocode.codeName);
        this.promoCodeFrom.controls["availableQuantity"].setValue(
          response.promocode.availableQuantity
        );
        this.promoCodeFrom.controls["businessLimitQuantity"].setValue(
          response.businessLimitQuantity
        )
        this.promoCodeFrom.controls["precentage"].setValue(response.promocode.precentage);
        this.promoCodeFrom.controls["maxPrecentageValue"].setValue(response.promocode.maxPrecentageValue);
        this.promoCodeFrom.controls["expiry"].setValue(response.promocode.expiry);
        if (response.PaymentOptionId) {
          this.promoCodeFrom.controls["PaymentOptionId"].setValue(response.PaymentOptionId);
        } else {
          this.promoCodeFrom.controls["PaymentOptionId"].setValue(0);
        }

        if (response.promocode.description) {
          this.promoCodeFrom.controls["description"].setValue(
            response.promocode.description
          );
        }
      } else {
        this.initForm();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async initForm() {
    try {
      this.promoCodeFrom = this.formValidator.createForm([
        {
          fieldName: "codeName",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
                field: "Promo Code Name"
              })
            },
            {
              validatorFn: Validators.minLength(2),
              message: this.translate.instant(
                "FORMS.VALIDATION.MINIMUM_LENGTH",
                { field: "Promo Code Name", value: 2 }
              )
            },
            {
              validatorFn: CustomValidators.customPattern(/^\S*$/u),
              message: this.translate.instant("FORMS.VALIDATION.FORMAT", {
                field: "Promo Code Name"
              })
            },
            {
              validatorFn: Validators.pattern(this.patternName),
              message: this.translate.instant("FORMS.VALIDATION.FORMAT", {
                field: "Promo Code Name"
              })
            }
          ]
        },
        {
          fieldName: "availableQuantity",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
                field: "Promo Code Quantity"
              })
            },
            {
              validatorFn: Validators.min(this.minQuantity),
              message: this.translate.instant("FORMS.VALIDATION.MINIMUM", {
                field: "Promo Code Quantity",
                value: this.minQuantity
              })
            },
            {
              validatorFn: Validators.max(this.maxQuantity),
              message: this.translate.instant("FORMS.VALIDATION.MAXIMUM", {
                field: "Promo Code Quantity",
                value: this.maxQuantity
              })
            }
          ]
        },
        {
          fieldName: "businessLimitQuantity",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
                field: "Promo Code per business Quantity"
              })
            },
            {
              validatorFn: Validators.min(this.minQuantity),
              message: this.translate.instant("FORMS.VALIDATION.MINIMUM", {
                field: "Promo Code per business Quantity",
                value: this.minQuantity
              })
            },
            {
              validatorFn: Validators.max(this.maxQuantity),
              message: this.translate.instant("FORMS.VALIDATION.MAXIMUM", {
                field: "Promo Code per business Quantity",
                value: this.maxQuantity
              })
            }
          ]
        }
        ,{
          fieldName: "expiry",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
                field: "Promo Code Expiry"
              })
            },
            {
              validatorFn: CustomValidators.dateInTheFuture,
              message: this.translate.instant("FORMS.VALIDATION.IVALID", {
                field: "Expiration Date"
              })
            }
          ]
        },
        {
          fieldName: "PaymentOptionId",
          defaultValue: this.selectedPaymentOption,
          validators: [
            {
              validatorFn: Validators.required,
              message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
                field: "paymentOptions"
              })
            }
          ]
        },
        {
          fieldName: "description",
          defaultValue: null,
          validators: []
        },
        {
          fieldName: "precentage",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
                field: "Promo Code Percentage"
              })
            },
            {
              validatorFn: Validators.min(1),
              message: this.translate.instant("FORMS.VALIDATION.MINIMUM", {
                field: "Promo Code Percentage",
                value: 1
              })
            },
            {
              validatorFn: Validators.max(100),
              message: this.translate.instant("FORMS.VALIDATION.MAXIMUM", {
                field: "Promo Code Percentage",
                value: 100
              })
            }
          ]
        },
		{
			fieldName: "maxPrecentageValue",
			defaultValue: null,
			validators: [
				{
					validatorFn: Validators.min(1),
					message: this.translate.instant("FORMS.VALIDATION.MINIMUM", {
						field: "Max Value",
						value: 1
					})
				}
			]
		},
      ]);
      this.fetchPaymentOptionsService.setParams({});
      const fetchedPaymentOptions = await this.fetchPaymentOptionsService.make();
      this.paymentOptions = [
        ...fetchedPaymentOptions.map(({ id, name }) => ({ id, name })),
        { id: 0, name: 'All' },
      ];
    } catch (err) { }
  }

  async onSubmit(promoCodeValues: any) {
    try {
      this.error = false;
      if (this.editMode) {
        if (promoCodeValues.PaymentOptionId === 0) {
          promoCodeValues.PaymentOptionId = null;
        }
        this.editSystemPromocodeService.setParams(promoCodeValues);
        await this.editSystemPromocodeService.make();
      } else {
        this.editMode = false;

        if (promoCodeValues.PaymentOptionId === 0) {
          promoCodeValues.PaymentOptionId = null;
        }

        this.createSystemPromo.setParams(promoCodeValues);
        await this.createSystemPromo.make();
        const dialogRef = this.dialog.open(PromocodeModalComponent, {
          width: "400px",
          data: {
            name: promoCodeValues.codeName
          }
        });
        await dialogRef.afterClosed().toPromise();

        this.snackbar.open(
          `PromoCode ${promoCodeValues["codeName"]} has been created`,
          '',
          { duration: 3000 }
        );
      }
      this.router.navigate(["/admin/actions/systemPromocode/manage"]);
    } catch (err) {
      this.error = err.faultyRequest.error.message;
    }
  }
}

